<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.addDocument')"
        :submit="submitAddDocument"
        :rules="rulesAddDocument"
        no-reset
        @close="closeOverSide">
        <hts-card :title="$t('labels.generalInformation')">
            <!-- BA yêu cầu ẩn tính năng tạo hợp đồng 21/10/2024 -->
            <!--
              <div
              v-if="dataFormAddDocumentCooperator.type === 'CONTRACT'"
              class="mb-3 text-right">
              <hts-form-button
              v-if="!createContract"
              class="mt-11"
              size="small"
              type="button"
              icon-name="hi-plus-circle-icon"
              @click="activeFormCreateContract">
              {{ $t('labels.createContract') }}
              </hts-form-button>

              <hts-form-button
              v-if="createContract"
              class="mt-11"
              size="small"
              type="button"
              icon-name="hi-arrow-up-tray-icon"
              @click="disableFormCreateContract">
              {{ $t('labels.selectFile') }}
              </hts-form-button>
              </div>
            -->
            <hts-form-select
                v-model="dataFormAddDocumentCooperator.type"
                :label="$t('labels.type')"
                :items="typeDocument"
                key-id="value"
                key-label="title"
                required
                prop="type"
                name="type" />
            <hts-form-select
                v-if="typeCooperator.length >= 2 && dataFormAddDocumentCooperator.type === 'CONTRACT'"
                v-model="dataFormAddDocumentCooperator.contractFor"
                :label="$t('labels.contractFor')"
                :items="selectTypeCooperator"
                key-id="value"
                key-label="title"
                required
                prop="contractFor"
                name="contractFor" />
            <hts-form-file
                v-if="!createContract || dataFormAddDocumentCooperator.type !== 'CONTRACT'"
                ref="file"
                v-model="fileDocument"
                :required="true"
                type="file"
                :label="$t('labels.selectFile')"
                :color="props.color"
                name="document"
                prop="document" />
            <hts-form-input
                v-model="dataFormAddDocumentCooperator.fileName"
                :label="$t('labels.fileName')"
                :color="props.color"
                name="fileName"
                prop="fileName" />
            <hts-form-input
                v-model="dataFormAddDocumentCooperator.description"
                :label="$t('labels.description')"
                :color="props.color"
                name="description"
                prop="description" />
            <hts-form-date
                v-if="dataFormAddDocumentCooperator.type === 'CONTRACT'"
                v-model="dataFormAddDocumentCooperator.effectiveDate"
                :label="$t('labels.effectiveDate')"
                type="date"
                :color="props.color"
                name="effectiveDate"
                prop="effectiveDate" />
            <hts-form-date
                v-if="dataFormAddDocumentCooperator.type === 'CONTRACT'"
                v-model="dataFormAddDocumentCooperator.dueDate"
                :label="$t('labels.dueDate')"
                type="date"
                :color="props.color"
                name="dueDate"
                prop="dueDate" />

            <hts-form-toggle
                v-if="dataFormAddDocumentCooperator.type === 'CONTRACT' && createContract"
                v-model="dataFormAddDocumentCooperator.isSendEmailApprover"
                :label="$t('labels.isSendEmailApprover')"
                color="primary"
                label-right />
        </hts-card>
        <hts-card
            v-if="dataFormAddDocumentCooperator.contractFor === 'CUSTOMER' && dataFormAddDocumentCooperator.type === 'CONTRACT'"
            :title="$t('labels.creditTerms')">
            <div class="grid gap-4">
                <hts-form-radio
                    v-model="dataFormAddDocumentCooperator.creditTermsBy"
                    :label="$t('labels.creditTermsBy')"
                    required
                    :items="[
                        { id: 'day', label: $t('labels.day') },
                        { id: 'month', label: $t('labels.month') }
                    ]"
                    name="creditTermsBy"
                    prop="creditTermsBy" />
                <hts-form-input
                    v-if="dataFormAddDocumentCooperator.creditTermsBy === 'month'"
                    v-model="dataFormAddDocumentCooperator.dayOfTheMonth"
                    :label="$t('labels.dayOfTheMonth')"
                    type="number"
                    :color="props.color"
                    name="dayOfTheMonth"
                    prop="dayOfTheMonth"
                    required />
                <hts-form-input
                    v-if="dataFormAddDocumentCooperator.creditTermsBy === 'month'"
                    v-model="dataFormAddDocumentCooperator.monthsCreditTerms"
                    :label="$t('labels.monthsCreditTerms')"
                    type="number"
                    :color="props.color"
                    name="monthsCreditTerms"
                    prop="monthsCreditTerms"
                    required />
                <hts-form-input
                    v-if="dataFormAddDocumentCooperator.creditTermsBy === 'day'"
                    v-model="dataFormAddDocumentCooperator.duration"
                    :label="$t('labels.duration')"
                    type="number"
                    :color="props.color"
                    name="duration"
                    prop="duration"
                    required />
                <hts-form-input
                    v-model="dataFormAddDocumentCooperator.spendingLimit"
                    :label="$t('labels.spendingLimit')"
                    type="number"
                    :color="props.color"
                    required
                    name="spendingLimit"
                    prop="spendingLimit" />
            </div>
        </hts-card>

        <hts-modal
            :show="openPopupConfirmDueDate"
            :title="$t('labels.confirmDueDate')"
            type="confirm"
            :content="$t('labels.confirmDueDateDetail')"
            @hide="openPopupConfirmDueDate = false"
            @confirm="handleSubmitFormAddDocumentCooperator" />
    </hts-drawer>
</template>

<script lang="ts" setup>
import { ICooperatorDocument } from '~/pages/trucker-[id]/partner/-components/imports/form'

const props = defineProps({
  codePartner: {
    type: String,
    default: ''
  },
  color: {
    type: String,
    default: 'theme'
  }
})
const _initForm = {
  cooperatorDocument: undefined,
  fileName: '',
  description: '',
  type: '',
  dueDate: '',
  effectiveDate: '',
  creditTermsBy: '',
  dayOfTheMonth: null,
  monthsCreditTerms: null,
  duration: null,
  spendingLimit: null,
  isSendEmailApprover: false,
  contractFor: ''
}
const typeCooperator: { [key: string]: any } = ref([])
const cooperatorId = computed(() => props.codePartner)
const createContract = ref(false)
const openPopupConfirmDueDate = ref(false)

const undo = () => {
  dataFormAddDocumentCooperator.value = { ..._initForm }
  fileDocument.value = ''
  openPopupConfirmDueDate.value = false
}
const dataFormAddDocumentCooperator = ref<ICooperatorDocument>({ ..._initForm })
const emits = defineEmits(['close', 'refreshTables'])
const fileDocument = ref<File | string>('')

const visible = ref(false)
const creating = ref(false)

const open = (type: { [key: string]: any }) => {
  if (type.length === 1) {
    dataFormAddDocumentCooperator.value.contractFor = type[0]
  }
  typeCooperator.value = type
  visible.value = true
}
defineExpose({
  open
})

const selectTypeCooperator = computed(() => {
  return typeCooperator.value.map((type: string) => {
    return {
      value: type,
      title: $t(`labels.${type.toLowerCase()}`)
    }
  })
})

const loading = ref(false)

const submitAddDocument = async () => {
  if (typeCooperator.value && dataFormAddDocumentCooperator.value.contractFor === 'CUSTOMER' && dataFormAddDocumentCooperator.value.type === 'CONTRACT') {
    const dayOfTheMonth = dataFormAddDocumentCooperator.value.dayOfTheMonth
    const monthsCreditTerms = dataFormAddDocumentCooperator.value.monthsCreditTerms
    const duration = dataFormAddDocumentCooperator.value.duration
    if (!(dayOfTheMonth && monthsCreditTerms) && !duration) {
      process.client && $toast().error($t('notifications.documentValidateDateOfTheMonthAndDuration'))
      return
    }
  }

  if (dataFormAddDocumentCooperator.value.type === 'CONTRACT') {
    if (!dataFormAddDocumentCooperator.value.dueDate) {
      openPopupConfirmDueDate.value = true
      return
    }
  }

  await handleSubmitFormAddDocumentCooperator()
}

const handleSubmitFormAddDocumentCooperator = async () => {
  const dataForm = new FormData()
  dataForm.append('fileName', dataFormAddDocumentCooperator.value.fileName)
  dataForm.append('cooperator', cooperatorId.value)
  dataForm.append('description', dataFormAddDocumentCooperator.value.description)
  dataForm.append('type', dataFormAddDocumentCooperator.value.type)

  const typeDocument = dataFormAddDocumentCooperator.value.type
  if (typeDocument === 'CONTRACT') {
    dataForm.append('dueDate', dataFormAddDocumentCooperator.value.dueDate || '')
    dataForm.append('effectiveDate', dataFormAddDocumentCooperator.value.effectiveDate || '')
    dataForm.append('contractFor', dataFormAddDocumentCooperator.value.contractFor || '')
  }

  if (typeDocument === 'CONTRACT' && typeCooperator.value && dataFormAddDocumentCooperator.value.contractFor === 'CUSTOMER') {
    dataForm.append(
      'credit',
      JSON.stringify({
        creditTermsBy: dataFormAddDocumentCooperator.value.creditTermsBy,
        dayOfTheMonth: dataFormAddDocumentCooperator.value.dayOfTheMonth,
        duration: dataFormAddDocumentCooperator.value.duration,
        spendingLimit: dataFormAddDocumentCooperator.value.spendingLimit,
        monthsCreditTerms: dataFormAddDocumentCooperator.value.monthsCreditTerms
      })
    )
  }

  if (createContract.value) {
    dataForm.append('isSendEmailApprover', String(dataFormAddDocumentCooperator.value.isSendEmailApprover))
  }

  if (!createContract.value || typeDocument !== 'CONTRACT') {
    dataForm.append('cooperatorDocument', fileDocument.value)
  }

  if (createContract.value && typeDocument === 'CONTRACT') {
    dataForm.append('createContract', 'true')
  } else {
    dataForm.append('createContract', 'false')
  }

  const api = {
    method: 'POST',
    url: '/partner/document/upload'
  }

  await $api(api, { body: dataForm })
    .then((data: any) => {
      creating.value = true
      const resData: any = data.data.value

      if (resData.success) {
        process.client && $toast().success($t('notifications.addSuccessDocument'))
        loading.value = false
        fileDocument.value = ''
        undo()
        emits('refreshTables')
      }
      creating.value = false
      visible.value = false
    })
    .catch(() => {
      creating.value = false
    })
}

const typeDocument = ref([
  {
    value: 'CONTRACT',
    title: $t('labels.contract')
  },
  {
    value: 'CERTIFICATEBUSINESS',
    title: $t('labels.certificateBusiness')
  },
  {
    value: 'OTHER',
    title: $t('labels.other')
  }
])

const rulesAddDocument = computed(() => {
  const rules = {
    type: 'required'
  } as { [key: string]: string }

  const typeDocument = dataFormAddDocumentCooperator.value.type

  if (!createContract.value || (typeDocument && typeDocument !== 'CONTRACT')) {
    rules.document = 'required|fileSize:10'
  }

  if (typeDocument && typeDocument === 'CONTRACT') {
    if (dataFormAddDocumentCooperator.value.effectiveDate) {
      rules.dueDate = `date_bigger:${dataFormAddDocumentCooperator.value.effectiveDate}`
    }
  }

  if (typeDocument === 'CONTRACT' && typeCooperator.value && dataFormAddDocumentCooperator.value.contractFor === 'CUSTOMER') {
    rules.creditTermsBy = 'required'
    if (dataFormAddDocumentCooperator.value.creditTermsBy === 'day') {
      rules.duration = 'required|integer'
    }
    if (dataFormAddDocumentCooperator.value.creditTermsBy === 'month') {
      rules.dayOfTheMonth = 'required|min_value:1|max_value:28|integer'
      rules.monthsCreditTerms = 'required|integer'
    }
    rules.spendingLimit = 'required'
  }

  return rules
})

const activeFormCreateContract = () => {
  createContract.value = true
}

const disableFormCreateContract = () => {
  createContract.value = false
}

const closeOverSide = () => {
  visible.value = false
}
</script>
